import {IAccomodation} from "@/model/Accomodation"

export interface IHasAccomodation {
    getAccomodation(): IAccomodation | null
    setAccomodation(accomodation: IAccomodation): void
}

function hasAccomodation<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasAccomodation {
        private accomodation: IAccomodation | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getAccomodation(): IAccomodation | null {
            return this.accomodation
        }
        public setAccomodation(accomodation: IAccomodation): void {
            this.accomodation = accomodation
        }
    };
}

export default hasAccomodation